import { TextMessagingConfiguration } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner } from '@optimus-web/core';
import { AvailableBudgetBanner } from './AvailableBudgetBanner/AvailableBudgetBanner';

interface ConfigurationBanner {
    configuration: TextMessagingConfiguration;
}

export const ConfigurationBanner = ({ configuration }: ConfigurationBanner) => {
    const { availableBudget, shortName } = configuration;

    if (shortName.value == null) {
        return (
            <Banner
                variant="warning"
                primaryText={<LocalizedText textKey={TextKey.TextMessagingConfigurationMissingShortNameBannerText} />}
            />
        );
    }

    const {
        fee,
        maxMonthlyBudget,
        remainingBudget,
        rolloverFromPriorMonths,
        startingBudget,
        startingBudgetForNextMonth,
        toppedUpFee,
    } = availableBudget;

    return (
        <AvailableBudgetBanner
            fee={fee}
            maxMonthlyBudget={maxMonthlyBudget}
            remainingBudget={remainingBudget}
            rolloverFromPriorMonths={rolloverFromPriorMonths}
            startingBudget={startingBudget}
            startingBudgetForNextMonth={startingBudgetForNextMonth}
            toppedUpFee={toppedUpFee}
        />
    );
};
